import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "100%",
  height: "100%",
  viewBox: "0 0 11 11",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M10.495 0.183058C10.251 -0.0610194 9.85523 -0.0610194 9.61115 0.183058L5.33905 4.45516L1.06694 0.183058C0.822864 -0.0610194 0.427136 -0.0610194 0.183058 0.183058C-0.0388305 0.404947 -0.0590022 0.752167 0.122543 0.996843L0.183058 1.06694L4.45516 5.33905L0.183058 9.61115L0.122543 9.68125C-0.0590023 9.92592 -0.0388305 10.2731 0.183058 10.495C0.427136 10.7391 0.822864 10.7391 1.06694 10.495L5.33905 6.22293L9.61115 10.495C9.85523 10.7391 10.251 10.7391 10.495 10.495C10.7169 10.2731 10.7371 9.92592 10.5555 9.68125L10.495 9.61115L6.22293 5.33905L10.495 1.06694L10.5555 0.996843C10.7371 0.752167 10.7169 0.404947 10.495 0.183058Z",
      fill: "currentColor"
    }, null, -1)
  ]))]))
}
export default { render: render }